export default theme => ({
  chip: {
    margin: theme.spacing(1) / 4,
  },
});
